import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable()
export class SettingsService {
  constructor() {

  }

  get apiUrl(): string {
 //   return 'https://ft-dev.sprinterra.com/api'
   return environment.apiUrl;
  }

  get production(): boolean {
    return environment.production;
  }


  get logLevel(): number {
    return environment.logLevel;
  }
}
